import th from './th';
import en from './en';

export default {
	th,
	en,
};
